<template>
  <div class="container">
    <p class="h2">测吧购课协议</p>
    <p class="bold">在线购买服务协议</p>
    <p class="txt mr-t-24">欢迎您在拉勾上购买由 <span class="bold">拉勾合作第三方主体——测吧（北京）科技有限公司</span> （以下简称“测吧”）提供的《测试开发技术专栏》、《3 天接口测试实战训练营》、《测试开发实战训练营》（“本服务”）。为保障您能更好地享受及使用相关服务，您应当阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是设定、免除或限制责任的相应条款（尤其是加粗、下划线的内容）。除非您已阅读并接受本协议所有条款，否则您不应当继续购买或使用本服务。您对本服务的任何购买或使用行为即视为您已阅读并同意本协议的约束。</p>
    <p class="txt">请注意，您作为拉勾招聘平台用户购买及使用本服务，还应同时遵守《拉勾网用户协议》《拉勾网隐私政策》《拉勾网在线增值服务协议》。</p>
    <p class="txt">本协议内容同时包括拉勾可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，用户同样应当遵守。</p>

    <p class="title mr-t-24">一、服务内容及服务规则</p>
    <p class="txt">服务内容及服务规则以您实际购买时页面具体课程说明及订阅须知为准。</p>
    <p class="title mr-t-24">二、服务购买</p>
    <p class="txt">2.1 您须先成为拉勾的注册用户后才能通过拉勾平台购买或使用本服务。</p>
    <p class="txt">2.2 您可根据自身需求购买本服务。课程服务的价格以结算页面显示为准。</p>
    <p class="txt">2.3 您须通过服务页面指定的支付方式进行付款，目前本平台支持支付宝、微信支付等支付方式，未来可能会增加其他支付方式或对现有支付方式进行调整，请您以平台届时相关服务页面公布、实际提供的支付方式为准。您使用第三方支付工具购买本服务的，还应相应遵守第三方服务提供商的相应规则。</p>
    <p class="txt">2.4 服务退费规则以实际购买时页面具体课程说明为准。如允许申请退款的，您理解并同意随同该服务购买而赠送的系列赠品 （如有）也将一并退还或一并失效。</p>
    <p class="title mr-t-24">三、个人信息收集、使用及保护</p>
    <p class="txt underline">3.1 您理解并同意，由于本课程需在测吧平台学习，因此您在拉勾购买本服务后，拉勾将向测吧安全传输您当前账号所使用的用户名及手机号码，以便测吧及时联系您并尽快提供课程服务。您也可以主动添加测吧服务助理企业微信。为更有效地提供服务，测吧可能会进一步请您提供更详细的个人信息，如工作情况等，请您根据自身情况慎重选择是否提供以及提供信息的详细程度，拉勾不对此类信息承担任何信息保护的责任。</p>
    <p class="txt bold">3.2 请您注意，拉勾及测吧在服务期间不会要求您提供本服务协议列明的信息种类以外的其他个人信息，如您收到声称为拉勾或测吧人员要求您提供与课程服务无关的信息或个人敏感信息（如身份证号码、银行卡号码、短信验证码）的，请勿提供并立即联系服务助理或拉勾客服人员。</p>
    <p class="txt">3.3 拉勾及其授权合作第三方承诺严格遵守国家法律法规并仅按照相关法律的要求及本协议列明的方式收集、使用您的个人信息。在未经您同意和授权的情况下，除国家法律法规或者政府职权部门依法要求提供外，拉勾不会主动对外提供您在本页面提交的任何个人信息。</p>
    <p class="txt">3.4 请您知悉并理解，由于技术的限制以及可能存在的各种恶意手段，您接入拉勾服务所用的系统和通讯网络，有可能因拉勾可控范围外的因素而出现问题。因此，拉勾强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人</p>
    <p class="txt">3.5 拉勾将尽商业上的合理努力保障您在拉勾中的数据存储安全，以保障您的个人信息免遭丢失、盗用和误用，以及避免被擅自取阅、披露、更改或销毁。但是，拉勾并不能就此提供完全保证您的个人信息不会受到任何侵害，您需根据自身需求自行备份服务中的相关数据，拉勾不对您在拉勾及服务中相关数据的删除或储存失败负责。</p>
  </div>
</template>
<script>
export default {
  name: "docH5",

  data() {
    return {

    };
  },
  methods: {

  },
};
</script>
<style lang='less' scoped>
.container {
  overflow-y: auto;
  padding: 32PX;
  box-sizing: border-box;
}
.h2 {
  text-align: center;
  font-size: 32PX;
  font-weight: bold;
  margin-bottom: 32PX;
}
p {
  font-size: 24PX;
  margin-bottom: 8PX;
}
.mr-t-24 {
  margin-top: 20PX;
}
.title {
  font-weight: bold;
}
.txt {
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.oblique {
  font-style: oblique;
}
.bold {
  font-weight: bold;
}

</style>
